<template>
  <el-popover
    placement="right"
    :width="280"
    trigger="hover"
    popper-class="appointment-popover"
  >
    <template #reference>
      <slot />
    </template>
    <div v-if="appointment">
      <div class="popover-main">
        <div class="popover-title">
          <template v-if="appointment.client_name">
            {{ appointment.client_name }}
          </template>
          <template v-else>
            <span style="color: var(--cal-danger);">Клиент удалён</span>
          </template>
        </div>
        <div class="popover-phone">
          <template v-if="appointment.client_phone">
            {{ appointment.client_phone }}
          </template>
          <template v-else>
            <span style="color: var(--ui-color-text-disabled);">—</span>
          </template>
        </div>
        <div class="popover-services">
          <span v-for="srv in appointment.services" :key="srv.id">
            {{ srv.name }} <span v-if="srv.duration">({{ srv.duration }} мин)</span>
            <span v-if="!srv.last">, </span>
          </span>
        </div>
        <div class="popover-times">{{ appointment.start_time }} – {{ calcEnd }}</div>
        <div class="popover-status" :class="statusClass">{{ statusLabel }}</div>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'AppointmentPopover',
  props: {
    appointment: { type: Object, required: true }
  },
  computed: {
    calcEnd() {
      const t = this.timeToMin(this.appointment.start_time)
      const duration = this.appointment.duration_time ||
        (this.appointment.services || []).reduce((s, x) => s + (x.duration || 0), 0)
      return this.formatTime(t + duration)
    },
    statusClass() {
      const st = this.appointment.status
      if (st) return `status-${st}`
      return `status-${this.getStatus(this.appointment)}`
    },
    statusLabel() {
      const STATUS_LABELS = {
        planned: 'Запланировано',
        confirmed: 'Подтверждено',
        done: 'Выполнено',
        no_show: 'Не пришёл',
        canceled: 'Отменено'
      }
      const st = this.appointment.status
      return STATUS_LABELS[st] || 'Статус не определён'
    }
  },
  methods: {
    timeToMin(str) {
      if (!str) return 0
      const [h, m] = str.split(':').map(Number)
      return h * 60 + m
    },
    formatTime(t) {
      const h = Math.floor(t / 60), m = t % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },
    getStatus(app) {
      const now = new Date()
      const today = now.toISOString().slice(0, 10)
      const start = this.timeToMin(app.start_time)
      const duration = app.duration_time ||
        (app.services || []).reduce((sum, s) => sum + (s.duration || 0), 0)
      const end = start + duration
      const curr = now.getHours() * 60 + now.getMinutes()
      if (app.date < today || (app.date === today && end <= curr)) return 'past'
      if (app.date === today && start <= curr && curr < end) return 'current'
      return 'future'
    }
  }
}
</script>

<style scoped>
.appointment-popover {
  font-size: 15px;
  padding: 14px 12px;
  background: linear-gradient(135deg, #244b94 0%, #1a376d 100%);
  color: var(--cal-text-inverse);
  border: 1px solid #3669be;
  border-radius: 10px;
}
.popover-title {
  font-weight: 700;
  margin-bottom: 3px;
  color: var(--cal-text-inverse);
}
.popover-phone {
  color: var(--cal-text-regular);
  font-size: 13px;
  margin-bottom: 3px;
}
.popover-services {
  color: var(--cal-text-regular);
  font-size: 13px;
  margin-bottom: 3px;
  white-space: normal;
}
.popover-times {
  color: var(--cal-accent);
  font-size: 13px;
  margin-bottom: 4px;
}
.popover-status {
  font-size: 13px;
  margin-top: 2px;
  color: var(--cal-text-muted);
}
.popover-status.past {
  color: var(--ui-color-text-muted);
}
.popover-status.current {
  color: var(--cal-success);
  font-weight: 600;
}
.popover-status.future {
  color: var(--cal-accent);
  font-weight: 600;
}
.popover-status.status-planned { color: var(--ui-color-warning); font-weight: 600; }
.popover-status.status-confirmed { color: var(--cal-accent-strong); font-weight: 600; }
.popover-status.status-done { color: var(--cal-success); font-weight: 600; }
.popover-status.status-no_show { color: var(--ui-color-danger); font-weight: 600; }
.popover-status.status-canceled { color: var(--ui-color-text-disabled); font-weight: 600; }
</style>
